import React, { Component } from 'react';
import statusIcon from "../../../../../styles/img/NewPackSelector/table-heading-icon1.svg";

const TableHeading = ({ content }) => {
  const {  icon, text } = content
  return (
    <div className="tableHeading">
      <img className="tableHeading-icon" src={icon} alt="status"></img>
      <h6 className="tableHeading-text">{text}</h6>
    </div>
  );};

export default TableHeading;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/TableHeading.js